import { Admin } from "./Admin";
import { Redirect, Route, Switch } from "react-router-dom";
import { PrivateRoute } from "./PrivateRoute";
import { PublicRoute } from "./PublicRoute";
import { ResetPassword } from "./pages/ResetPassword";
import LandingPage from "./redesign/LandingPage";
import Home from "./pages/Home/Home";
import LoginPage from "./redesign/LoginPage";
import RegisterPage from "./redesign/RegisterPage";
import ForgotPasswordPage from "./redesign/ForgotPasswordPage";
import PrivacyPolicy from "./redesign/PrivacyPolicy";
import TermsPage from "./redesign/TermsPage";
import { Footer } from "./components/Footer";
import RedesignFooter from "./redesign/components/Footer";
import { Terms } from "./pages/Terms";
import { FAQs } from "./pages/FAQs";
import Reviews from "./pages/Review/Reviews";
import IGBConference from "./pages/IGBConference/IGBConference";
import { Profiles } from "./pages/Profiles";
import { Referral } from "./pages/Referral";
import ReactGA from "react-ga";
import { Toaster } from "react-hot-toast";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import { AuthProvider } from "./auth/JWTContext";

export const App = () => {
  ReactGA.initialize("UA-61473152-2");
  ReactGA.pageview(window.location.pathname);

  return (
      <AuthProvider>
        <Toaster
            position="top-center"
            toastOptions={{
              style: {
                maxWidth: "100%"
              }
            }}
        />
        <Switch>
          <Route exact path="/" component={LandingPage} />
          <PublicRoute path="/login" component={LoginPage} />
          <PublicRoute path="/signup" component={RegisterPage} />
          <PublicRoute path="/forgot" component={ForgotPasswordPage} />
          <Route exact path="/privacy" component={PrivacyPolicy} />
          <Route exact path="/terms" component={TermsPage} />
          <Route>
            <div className="wrapper">
              <Switch>
                <Route path="/reset_password" component={ResetPassword} />
                <Route path="/r/:referral_code" component={Referral} />
                <PrivateRoute path="/admin" component={Admin} />
                <Redirect to="/" />
              </Switch>
            </div>
            <div style={{ marginTop: 60 }}>
              <RedesignFooter />
            </div>
          </Route>
        </Switch>
      </AuthProvider>
  );
};
